import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Alert, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';


const PaymentCancel = () => {

  const navigate = useNavigate();

  const headerGenerated = useHeaderGenerator(
    'Payment Cancelled 🫠',
    ' ',
    []
  );

  return (
    <>
      {headerGenerated}
        <Card>
          <Card.Body>
            <p>Your payment wasn’t completed</p>
            <p>Don’t worry — <b>you haven’t been charged</b>, and you can try again whenever you’re ready.</p>
            <Alert variant="warning">
              <p>Complete your payment to activate your membership and start booking classes.</p>
              <Button className="btn-sm"variant="primary" onClick={() => navigate('/app/wod/memberships')}>Try Payment Again</Button>
            </Alert>
            <br/>
            <h4>Changed your mind?</h4>
            <p>You can return to your dashboard and continue exploring Rebirth.</p>
            <Button className="btn-sm" variant="success" onClick={() => navigate('/app/wod/dashboard')}>Return to Dashboard</Button>
            <br/><br/>
            <p>If you need help completing your payment, please contact your gym.</p>
          </Card.Body>
        </Card>
    </>
  );
};

export default PaymentCancel;
